"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PropertyValue = void 0;
var propertyValueCounter = 1;
var PropertyValue = /** @class */ (function () {
    function PropertyValue(label, uri, predicates) {
        this.id = propertyValueCounter++;
        this.label = label;
        this.uri = uri;
        this.predicates = predicates;
    }
    PropertyValue.prototype.addPredicate = function (predicate) {
        this.predicates.push(predicate);
    };
    return PropertyValue;
}());
exports.PropertyValue = PropertyValue;
